import { useNavigate } from "react-router-dom"; // Import useNavigate
import axios from "axios";
import { getNewAccessToken } from "./authUtils"; // Import the utility function for token refresh
import config from "../config";

// Custom hook to setup Axios with interceptors
const useAxios = () => {
  const navigate = useNavigate(); // Initialize useNavigate inside the hook

  // Create an Axios instance
  const axiosAPI = axios.create({
    baseURL: config.apiBaseUrl,
  });

  // Add a request interceptor
  axiosAPI.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  // Add a response interceptor
  axiosAPI.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      // console.log("Orignal ", originalRequest);

      // Only retry once
      if (originalRequest._retry) {
        return Promise.reject(error);
      }

      if (
        error.response &&
        error.response.status === 401 &&
        error.response.data.refreshTokenRequired
      ) {
        originalRequest._retry = true;

        const newAccessToken = await getNewAccessToken();

        if (newAccessToken) {
          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return axiosAPI(originalRequest); // retry request
        } else {
          // Don't navigate("/logout") here
          // Just clear context and tokens
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          window.location.href = "/login"; // safe reload
          return Promise.reject(error);
        }
      }

      return Promise.reject(error);
    },
  );

  return axiosAPI; // Return the Axios instance
};

export default useAxios;
